/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get PLAN constants

export const PLAN_REQUEST_GET = 'PLAN_REQUEST_GET';
export const PLAN_RESPONSE_GET_SUCCESS = 'PLAN_RESPONSE_GET_SUCCESS';
export const PLAN_RESPONSE_GET_FAIL = 'PLAN_RESPONSE_GET_FAIL'

export const PLAN_SELECTED = 'PLAN_SELECTED'
export const PLAN_SELECTED_BULK = 'PLAN_SELECTED_BULK'
export const PLAN_REQUEST_POST = 'PLAN_REQUEST_POST';
export const PLAN_RESPONSE_POST_FAIL = 'PLAN_RESPONSE_POST_FAIL';
export const  ADD_PLAN_RESPONSE_SUCCESS = 'ADD_PLAN_RESPONSE_SUCCESS';
export const  ADD_PLAN_RESET_SUCCESS_MSG_OR_ERROR = 'ADD_PLAN_RESET_SUCCESS_MSG_OR_ERROR';
export const FAILED_TO_GENERATE_PLAN = 'FAILED_TO_GENERATE_PLAN'


export const PLAN_REQUEST_PATCH = 'PLAN_REQUEST_PATCH';
export const PLAN_RESPONSE_PATCH_FAIL = 'PLAN_RESPONSE_PATCH_FAIL';
export const DELETE_PLAN_RESPONSE_SUCCESS = 'DELETE_PLAN_RESPONSE_SUCCESS'
export const RESET_PLAN_DELETE = 'RESET_PLAN_DELETE'
export const SUCCESSFULLY_DELETED= 'SUCCESSFULLY_DELETED'
export const FAILED_TO_DELETE = 'FAILED_TO_DELETE'
export const PLAN_GENERATED_SUCCESSFULLY = 'PLAN_GENERATED_SUCCESSFULLY'


export const PLAN_ADD_MODAL = 'PLAN_ADD_MODAL'
export const DELETE_ACTION_TRIGGER = 'DELETE_ACTION_TRIGGER'
export const PLAN_EDIT_MODAL = 'PLAN_EDIT_MODAL'

export const SET_PLAN_NAME = 'SET_PLAN_NAME';
export const SET_VALIDITY_TIME = 'SET_VALIDITY_TIME';
export const SET_RATE_LIMIT = 'SET_RATE_LIMIT';
export const SET_PLAN_DESCRIPTION = 'SET_PLAN_DESCRIPTION';
export const SET_TOTAL_QUOTA = 'SET_TOTAL_QUOTA';
export const SET_UPLOAD_QUOTA = 'SET_UPLOAD_QUOTA';
export const SET_DOWNLOAD_QUOTA = 'SET_DOWNLOAD_QUOTA';
export const SET_TIMEOUT_CRITERIA = 'SET_TIMEOUT_CRITERIA';
export const SET_PLAN_ID = 'SET_PLAN_ID';
export const RESET_PLAN_EDIT = 'RESET_PLAN_EDIT';
export const PLAN_SCCESSFULLY_UPDATED= 'PLAN_SCCESSFULLY_UPDATED'
export const RESET_PLAN_UPDATE = 'RESET_PLAN_UPDATE';

export const PLAN_REQUEST_EDIT = 'PLAN_REQUEST_EDIT';
export const EDIT_PLAN_RESPONSE_SUCCESS = 'EDIT_PLAN_RESPONSE_SUCCESS';
export const PLAN_RESPONSE_EDIT_FAIL = 'PLAN_RESPONSE_EDIT_FAIL';




